export default [
    {
        path: "emulation",
        redirect: "/emulation/list",
        name: "Thi đua",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Cá nhân chấm điểm",
                component: () =>
                    import(
                        "@/views/screens/emulation/SelfRatingManagement"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Cá nhân chấm điểm"
                },
            },
            {
                path: "create/:group_id",
                name: "Thêm mới chấm điểm",
                component: () =>
                    import(
                        "@/views/screens/emulation/SelfRatingCreate"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm mới bản tự chấm điểm"
                },
            },
            {
                path: "edit/:id",
                name: "Chỉnh sửa chấm điểm thi đua",
                component: () =>
                    import(
                        "@/views/screens/emulation/SelfRatingEdit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Sửa bản tự chấm điểm"
                },
            },
            {
                path: "detail/:id",
                name: "Chi tiết chấm điểm thi đua",
                component: () =>
                    import(
                        "@/views/screens/emulation/SelfRatingDetail"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Chi tiết chấm điểm thi đua"
                },
            },
            {
                path: "office_report",
                name: "Văn phòng tổng hợp",
                component: () =>
                    import(
                        "@/views/screens/emulation/GeneralOfficeReport"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Văn phòng tổng hợp thi đua"
                },
            },
            {
                path: "rankings_report",
                name: "Xếp loại lao động",
                component: () =>
                    import(
                        "@/views/screens/emulation/RankingsReport"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Tổng hợp xếp loại lao động"
                },
            },
            {
                path: "report",
                name: "Tổng hợp điểm thi đua của phòng/ban",
                component: () =>
                    import(
                        "@/views/screens/emulation/DepartmentReport"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Tổng hợp điểm thi đua của phòng/ban"
                },
            },
            {
                path: "department",
                name: "Phòng chấm điểm",
                component: () =>
                    import(
                        "@/views/screens/emulation/DepartmentRatingManagement"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Lãnh đạo phòng chấm điểm"
                },
            },
            {
                path: "department_edit/:id",
                name: "Phòng chấm điểm cho nhân viên",
                component: () =>
                    import(
                        "@/views/screens/emulation/DepartmentRatingEdit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Phòng chấm điểm cho nhân viên"
                },
            },
            {
                path: "group",
                name: "Quản lý nhóm thi đua",
                component: () =>
                    import(
                        "@/views/screens/emulation/EmulationGroupManagement"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Quản lý nhóm thi đua"
                },
            },
        ],
    }
]